import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.disability;

const getDisability = createSelector(getData, disability => values(disability));

export default getDisability;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getDisability.js